import type { Move, PlayerSide, Rule, Stone } from './types';

export const BOARD_SIZE = 15;

export function createBoard(): Stone[][] {
  return Array.from({ length: BOARD_SIZE }, () => Array<Stone>(BOARD_SIZE).fill(0));
}

export function boardFromMoves(moves: Move[]): Stone[][] {
  const board = createBoard();
  for (const move of moves) board[move.y][move.x] = move.side;
  return board;
}

export function isInside(x: number, y: number): boolean {
  return x >= 0 && y >= 0 && x < BOARD_SIZE && y < BOARD_SIZE;
}

function lineLength(board: Stone[][], x: number, y: number, dx: number, dy: number, side: PlayerSide): number {
  let count = 1;
  for (let step = 1; isInside(x + dx * step, y + dy * step) && board[y + dy * step][x + dx * step] === side; step += 1) count += 1;
  for (let step = 1; isInside(x - dx * step, y - dy * step) && board[y - dy * step][x - dx * step] === side; step += 1) count += 1;
  return count;
}

export function winningLine(board: Stone[][], move: Move, rule: Rule): Array<[number, number]> | null {
  const directions: Array<[number, number]> = [[1, 0], [0, 1], [1, 1], [1, -1]];
  for (const [dx, dy] of directions) {
    const length = lineLength(board, move.x, move.y, dx, dy, move.side);
    const wins = rule === 'freestyle' || (rule === 'renju' && move.side === 2) ? length >= 5 : length === 5;
    if (!wins) continue;
    const points: Array<[number, number]> = [];
    let startX = move.x;
    let startY = move.y;
    while (isInside(startX - dx, startY - dy) && board[startY - dy][startX - dx] === move.side) {
      startX -= dx;
      startY -= dy;
    }
    for (let i = 0; i < length; i += 1) points.push([startX + dx * i, startY + dy * i]);
    return points;
  }
  return null;
}

export function isBoardFull(moves: Move[]): boolean {
  return moves.length >= BOARD_SIZE * BOARD_SIZE;
}

export function notation(move: Move): string {
  return `${String.fromCharCode(65 + move.x)}${BOARD_SIZE - move.y}`;
}

export function nextSide(moves: Move[]): PlayerSide {
  return moves.length % 2 === 0 ? 1 : 2;
}
